import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import {
  Dropdown, Menu,
} from 'floating-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFilePdf,faBookReader,faStickyNote, faFileWord, faFilePowerpoint, faBook, faFileExcel, faFolder, faFolderPlus, faFolderOpen, faCalendar,faFile
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebook, faTwitter, faLinkedin, faWhatsapp, faGooglePlus
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VueHtmlToPaper from 'vue-html-to-paper'
import VueCurrencyFilter from 'vue-currency-filter'
import VueSignaturePad from 'vue-signature-pad'
import responsive from 'vue-responsive'
import router from './router'
import store from './store'
import App from './App.vue'
import '@/libs/acl'
// eslint-disable-next-line import/order
import i18n from '@/libs/i18n'
// Global Components
import './global-components'
// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import './registerServiceWorker'
import 'floating-vue/dist/style.css'
// 3rd party plugins
import * as Sentry from '@sentry/vue'

library.add(faFolder,faFile,faStickyNote,faBookReader, faFolderPlus, faBook, faFilePdf, faCalendar, faFolderOpen, faFileWord, faFacebook, faTwitter, faLinkedin, faWhatsapp, faGooglePlus, faFilePowerpoint, faFileExcel)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.use(VueSignaturePad)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(responsive)
// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueHtmlToPaper)
Vue.component('VDropdown', Dropdown)
Vue.component('VMenu', Menu)
Vue.use(VueCurrencyFilter,
  {
    symbol: '',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: '00',
  })
// import core styles

Vue.component('VDropdown', Dropdown)

require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
// Sentry.init({
//   Vue,
//   dsn: 'https://a80fcb3a405b2b7fda0f786e30b28812@o4507322054737920.ingest.us.sentry.io/4507322185875456',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', 'https://api.sikanii.com/api', 'https://api.sikanii.com/graphql'],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
